var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActionDocuments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_293_43564)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2359 5.5H10.7641C10.1552 5.5 9.5 6.05577 9.5 6.94547V41.0545C9.5 41.9442 10.1552 42.5 10.7641 42.5H37.2359C37.8448 42.5 38.5 41.9442 38.5 41.0545V6.94856C38.4957 6.05094 37.8397 5.5 37.2359 5.5ZM40 6.94547V41.0545C40 42.6826 38.7605 44 37.2359 44H10.7641C9.2395 44 8 42.6826 8 41.0545V6.94547C8 5.31738 9.2395 4 10.7641 4H37.2359C38.7605 4 39.9942 5.31738 40 6.94547Z",
    fill: "#4D5160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4596 32.2049C28.0706 32.2049 28.5652 31.6831 28.5652 31.0308C28.5652 30.3786 28.0706 29.8505 27.4538 29.8567H16.2634C15.6524 29.8567 15.1577 30.3786 15.1577 31.0308C15.1577 31.6769 15.6524 32.2049 16.2634 32.2049H27.4596Z",
    fill: "#4D5160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5349 25.3135C34.1459 25.3135 34.6405 24.7917 34.6405 24.1394C34.6405 23.4934 34.1459 22.9653 33.5349 22.9653H16.2634C15.6524 22.9653 15.1577 23.4872 15.1577 24.1394C15.1577 24.7855 15.6524 25.3135 16.2634 25.3135H33.5349Z",
    fill: "#4D5160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2179 18.4906C30.8289 18.4906 31.3236 17.9688 31.3236 17.3165C31.3236 16.6642 30.8289 16.1362 30.2179 16.1424H16.2634C15.6524 16.1424 15.1577 16.6642 15.1577 17.3165C15.1577 17.9625 15.6524 18.4906 16.2634 18.4906H30.2179Z",
    fill: "#4D5160"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_293_43564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 40,
    fill: "white",
    transform: "translate(8 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionDocuments);
export default __webpack_public_path__ + "static/media/action-documents.2f5fcc29a06c7dc2b00de507d2d5d04b.svg";
export { ForwardRef as ReactComponent };